module.exports = __webpack_public_path__ + "img/arrow_down.d4b080e5.svg";